module.exports = __webpack_public_path__ + "media/about-banner.3c6b1589.mp4";